/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface PatchedInitialSavedState
 */
export interface PatchedInitialSavedState {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  savedState?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly uuid?: string;
}

/**
 * Check if a given object implements the PatchedInitialSavedState interface.
 */
export function instanceOfPatchedInitialSavedState(
  value: object
): value is PatchedInitialSavedState {
  return true;
}

export function PatchedInitialSavedStateFromJSON(json: any): PatchedInitialSavedState {
  return PatchedInitialSavedStateFromJSONTyped(json, false);
}

export function PatchedInitialSavedStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedInitialSavedState {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    savedState: json["saved_state"] == null ? undefined : json["saved_state"],
    id: json["id"] == null ? undefined : json["id"],
    uuid: json["uuid"] == null ? undefined : json["uuid"],
  };
}

export function PatchedInitialSavedStateToJSON(json: any): PatchedInitialSavedState {
  return PatchedInitialSavedStateToJSONTyped(json, false);
}

export function PatchedInitialSavedStateToJSONTyped(
  value?: Omit<PatchedInitialSavedState, "url" | "simulation" | "id" | "uuid"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    saved_state: value["savedState"],
  };
}
